/** 質問フォーム用 */
export const TEXT_BOX: number = 0;
export const NUMBER_BOX: number = 1;
export const CHECK_BOX: number = 2;
export const RADIO_BUTTON: number = 3;
export const SELECT_BOX: number = 4;
export const ADDRESS_FORM: number = 5;
export const MAIL_BOX: number = 6;
export const DATE_BOX: number = 7;
export const TELL_BOX: number = 8;

export const status: any = [
  { value: 1, label: "初回面談予約済" },
  { value: 2, label: "初回面談未実施" },
  { value: 3, label: "初回面談済" },
  { value: 4, label: "追客アポ無" },
  { value: 5, label: "追客アポ有" },
  { value: 6, label: "申込済アポ無" },
  { value: 7, label: "申込済" },
  { value: 8, label: "契約済" },
  { value: 9, label: "着工承認済" },
  { value: 10, label: "着工済" },
  { value: 11, label: "上棟済" },
  { value: 12, label: "見学会中" },
  { value: 13, label: "引渡済" },
  { value: 14, label: "アフター1回目" },
  { value: 15, label: "アフター2回目" },
  { value: 16, label: "アフター3回目" },
  { value: 17, label: "アフター" }
];
export const status2: any = [
  { value: 1, label: "初回面談予約済" },
  { value: 2, label: "初回面談未実施" },
  { value: 3, label: "初回面談済" },
  { value: 4, label: "追客アポ無" },
  { value: 5, label: "追客アポ有" },
  { value: 6, label: "契約済" },
  { value: 7, label: "着工承認済" },
  { value: 8, label: "着工済" },
  { value: 9, label: "上棟済" },
  { value: 10, label: "見学会中" },
  { value: 11, label: "引渡済" },
  { value: 12, label: "アフター" }
];
export const ranks: any = [
  { value: "1", label: "S" },
  { value: "2", label: "A" },
  { value: "3", label: "B" },
  { value: "4", label: "C" },
  { value: "5", label: "D" },
  { value: "6", label: "E" },
  { value: "7", label: "F" },
  { value: "8", label: "G" }
];
export const ranks_ob: any = [
  { value: "1", label: "プラチナ" },
  { value: "2", label: "ゴールド" },
  { value: "3", label: "シルバー" },
  { value: "4", label: "ブロンズ" }
];

